export const SETUP = 'SETUP';
export const SET_TOKEN = 'SET_TOKEN';
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const CLEAR_REDIRECT_PATH = 'CLEAR_REDIRECT_PATH';
export const REDIRECT_PATH = `redirect_path`;
